/* eslint-disable quotes */
export function mobileNav() {
    const body = $("body");
    const btnMenu = $(".btn-menu");
    const arrowLink = `<button class="arrow decor"><svg width="16" height="16" fill="currentColor" class="bi bi-chevron-down desktop-decor" viewBox="0 0 16 16"> <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/> </svg>
<svg class="mobile-decor" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.002 1.7518L6.00195 7.7518L0.00195306 1.7518L1.50195 0.248046L6.00195 4.7518L10.502 0.248047L12.002 1.7518Z" fill="white"/>
                        </svg></button>`;
    let activeMenuItem;

    btnMenu.on("click", function (e) {
        let $this = $(this);
        if (!$this.hasClass("open")) {
            $this.addClass("open");
            body.addClass("menu-opened");
        } else {
            $this.removeClass("open");
            body.removeClass("menu-opened");
        }
        e.preventDefault();
    });

    $(arrowLink).insertBefore(".header .sub-menu");

    // function closeDropdown(e) {
    //     if (!$('.main-menu .menu-item-has-children').has(e.target).length > 0) {
    //         $('.main-menu .menu-item-has-children').removeClass('active').find(".sub-menu").slideUp();
    //         window.removeEventListener('click', closeDropdown);
    //     }
    // }

    $(document).on("click", ".main-menu .arrow", function (e) {
        const target = $(e.target);

        if (target.closest('.arrow').length) {
            activeMenuItem = target.closest('.arrow').parent();
            if (window.innerWidth < 1200) {
                if (!activeMenuItem.hasClass("active")) {
                    activeMenuItem.addClass("active").find(".sub-menu");
                } else{
                    activeMenuItem.removeClass("active").find(".sub-menu");
                }
            }
            if (window.innerWidth > 1200 && body.hasClass('touch')) {
                if (!activeMenuItem.hasClass("active")) {
                    activeMenuItem.siblings().removeClass('active');
                    activeMenuItem.addClass("active").find(".sub-menu").fadeIn();
                } else {
                    activeMenuItem.removeClass("active").find(".sub-menu").fadeOut();
                }
                // window.addEventListener('click', closeDropdown);
            }
        }
    });

    $(document).on("click", ".main-menu .parent-name", function () {
        $('.menu-item-has-children').removeClass('active');
    });

    $(document).on("click", ".main-menu > li > a", function (e) {
        const target = $(e.target);

        activeMenuItem = target.closest('.menu-item-button').parent();
        if (window.innerWidth < 1200) {
            if (!activeMenuItem.hasClass("active")) {
                activeMenuItem.addClass("active").find(".sub-menu");
            } else {
                activeMenuItem.removeClass("active").find(".sub-menu");
            }
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/mobileNav.js